function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import ReactDOM from 'react-dom';
import "regenerator-runtime/runtime.js";
import { ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { RetryLink } from '@apollo/client/link/retry';
import MutationQueueLink from '@adobe/apollo-link-mutation-queue';
import { Util } from '@magento/peregrine';
import { Adapter } from '@magento/venia-drivers';
import store from './store';
import app from '@magento/peregrine/lib/store/actions/app';
import App, { AppContextProvider } from '@magento/venia-ui/lib/components/App';
import { registerSW } from './registerSW';
var {
  BrowserPersistence
} = Util;
var apiBase = new URL('/graphql', location.origin).toString();

/**
 * The Venia adapter provides basic context objects: a router, a store, a
 * GraphQL client, and some common functions.
 */

// The Venia adapter is not opinionated about auth.
var authLink = setContext((_, _ref) => {
  var {
    headers
  } = _ref;
  // get the authentication token from local storage if it exists.
  var storage = new BrowserPersistence();
  var token = storage.getItem('signin_token');

  // return the headers to the context so httpLink can read them
  return {
    headers: _objectSpread(_objectSpread({}, headers), {}, {
      authorization: token ? "Bearer ".concat(token) : ''
    })
  };
});

// https://www.apollographql.com/docs/link/links/error/
var errorLink = onError(_ref2 => {
  var {
    graphQLErrors,
    networkError,
    response
  } = _ref2;
  if (graphQLErrors) graphQLErrors.forEach(_ref3 => {
    var {
      message,
      locations,
      path
    } = _ref3;
    return console.log("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
  });
  if (networkError) console.log("[Network error]: ".concat(networkError));
});

// @see https://www.apollographql.com/docs/link/composition/.
var apolloLink = ApolloLink.from([new MutationQueueLink(), new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true
  },
  attempts: {
    max: 5,
    retryIf: error => error && navigator.onLine
  }
}), authLink, Adapter.storeLink, errorLink,
// An apollo-link-http Link
Adapter.apolloLink(apiBase)]);
ReactDOM.render( /*#__PURE__*/React.createElement(Adapter, {
  apiBase: apiBase,
  apollo: {
    link: apolloLink
  },
  store: store
}, /*#__PURE__*/React.createElement(AppContextProvider, null, /*#__PURE__*/React.createElement(App, null))), document.getElementById('root'));
registerSW();
window.addEventListener('online', () => {
  store.dispatch(app.setOnline());
});
window.addEventListener('offline', () => {
  store.dispatch(app.setOffline());
});